/*
 * Delivery dates for the sofa overview page.
 *
 * SINGLE SOURCE OF TRUTH: the Buunto date-picker app.
 * We do not compute a lead time of our own, so this page and the product-page
 * picker can never disagree. We read Buunto's live config and apply its rules:
 *   firstAvailableDateInDays - earliest offset from today
 *   availableWeekDays        - delivery days (includes SATURDAY)
 *   disabledDates            - blackout list, maintained in the Buunto admin
 *   timezoneId               - Europe/Brussels
 *
 * Buunto is an app embed, so its settings load on every page, not just products.
 * Black out a week in the app and this page follows with no theme edit.
 *
 * If Buunto is missing, nextDates() returns null and the caller hides the
 * calendar rather than showing an invented date.
 */
window.SwissRelaxDelivery = (function () {
  'use strict';

  var DAY_INDEX = {
    SUNDAY: 0, MONDAY: 1, TUESDAY: 2, WEDNESDAY: 3,
    THURSDAY: 4, FRIDAY: 5, SATURDAY: 6
  };

  function settings() {
    try {
      var s = window.Buunto && window.Buunto.datePicker && window.Buunto.datePicker.settings;
      if (!s || !s.availableWeekDays || !s.availableWeekDays.length) { return null; }
      return s;
    } catch (e) { return null; }
  }

  // "Today" in the shop timezone, not the visitor's, so a customer abroad sees
  // the same first available date as the picker will offer them.
  function shopToday(tz) {
    var now = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz || 'Europe/Brussels',
        year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(now);
      var bits = parts.split('-');
      return new Date(+bits[0], +bits[1] - 1, +bits[2]);
    } catch (e) {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
  }

  function iso(d) {
    var m = String(d.getMonth() + 1);
    if (m.length < 2) { m = '0' + m; }
    var day = String(d.getDate());
    if (day.length < 2) { day = '0' + day; }
    return d.getFullYear() + '-' + m + '-' + day;
  }

  function isAvailable(date, allowed, blocked) {
    return allowed.indexOf(date.getDay()) !== -1 && blocked.indexOf(iso(date)) === -1;
  }

  // Up to `count` available dates, starting from the first Buunto would offer.
  // Returns null when Buunto is unavailable.
  function nextDates(count) {
    var s = settings();
    if (!s) { return null; }

    var allowed = (s.availableWeekDays || [])
      .map(function (d) { return DAY_INDEX[d]; })
      .filter(function (n) { return typeof n === 'number'; });
    if (!allowed.length) { return null; }

    var blocked = s.disabledDates || [];
    var offset = typeof s.firstAvailableDateInDays === 'number' ? s.firstAvailableDateInDays : 1;
    var last = typeof s.lastAvailableDateInDays === 'number' ? s.lastAvailableDateInDays : 90;
    var want = count || 5;

    var cursor = shopToday(s.timezoneId);
    cursor.setDate(cursor.getDate() + offset);

    var out = [];
    for (var i = 0; i <= last && out.length < want; i++) {
      if (isAvailable(cursor, allowed, blocked)) { out.push(new Date(cursor.getTime())); }
      cursor.setDate(cursor.getDate() + 1);
    }
    return out.length ? out : null;
  }

  function deliversOnSaturday() {
    var s = settings();
    return !!(s && (s.availableWeekDays || []).indexOf('SATURDAY') !== -1);
  }

  return {
    settings: settings,
    nextDates: nextDates,
    deliversOnSaturday: deliversOnSaturday
  };
})();
